// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UOOw","signatureBlock":"Footer_signatureBlock__3rjto","signature":"Footer_signature__239fc"};